export const EVENT_PRODUCER_URL = '/ep-horizon/api/v1/et/'
